let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iZ7F9")).then(() => parcelRequire('2YvUG'));